<template>
  <div>
    <el-cascader
      filterable
      v-model="selectValue"
      :disabled="widget.options.disabled || config.disabled"
      :clearable="widget.options.clearable"
      :placeholder="widget.options.placeholder"
      :style="{ width: widget.options.width, maxHeight: '500px' }"
      :options="widget.options.remoteOptions"
      :props="{
        checkStrictly: widget.options.checkStrictly,
        ...widget.options.props,
      }"
      @[event]="eventMethod"
    >
    </el-cascader
    ><br />
    <el-input
      v-if="widget.options.isShowDetailInput"
      v-model="inputValue"
      :style="{ width: widget.options.width }"
      :placeholder="widget.options.placeholder2"
      @[event]="eventMethod"
      class="sw-address-info"
    ></el-input>
  </div>
</template>

<script>
import bus from '../../../util/eventBus'
import generateUtils from '../../../util/generateUtils'
export default {
  // 地址
  name: 'sw-address',
  props: ['widget', 'value', 'config'],
  data() {
    return {
      selectValue: [], // 级联选中地址
      inputValue: '', // 详细输入地址
    }
  },
  computed: {
    event() {
      return this.widget.eventOptions.eventType || null
    },
  },
  created() {
    if (this.value && this.value.selectValue) {
      this.selectValue = this.value.selectValue
    }
    if (this.value && this.value.inputValue) {
      this.inputValue = this.value.inputValue
    }
  },
  mounted() {
    this.getRemoteOptions()
  },
  methods: {
    // 自定义事件触发
    eventMethod() {
      bus.$emit('eventMethod', this.widget)
    },
    getRemoteOptions() {
      // 获取级联数据
      generateUtils.getCascaderOptions(this.widget)
    },
  },
  watch: {
    selectValue: function (val) {
      this.value.selectValue = val
    },
    inputValue: function (val) {
      this.value.inputValue = val
    },
    value: {
      handler: function (val) {
        this.selectValue = val.selectValue
        this.inputValue = val.inputValue
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.sw-address-info {
  margin-top: 5px;
}
</style>
<style>
.el-cascader-menu {
  max-height: 500px;
}
</style>
